// API configuration - uses environment variable with fallback
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:1337';
